import { AbstractListModel } from '@libs/factory/abstract-list/abstract-list.model';
import { marker } from '@colsen1991/ngx-translate-extract-marker';


export enum B2bProgramType {
    SingleProduct = 0,
    NumberOfTrips = 1,
}

export const b2bProgramTypeList: AbstractListModel[] = [
    {
        id: B2bProgramType.SingleProduct,
        title: marker('b2b.data.programType.0'),
    },
    {
        id: B2bProgramType.NumberOfTrips,
        title: marker('b2b.data.programType.1'),
    },
];
